'use strict';

if (!Symbol.species) {
    Symbol.species = Symbol.for('@@species');
}



//////////////////
// WEBPACK FOOTER
// ./~/ml-levenberg-marquardt/~/ml-matrix/src/symbol-species.js
// module id = 225
// module chunks = 0